import axios from 'axios'
import qs from 'qs'

export default axios.create({
  baseURL: process.env.PUBLIC_URL,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
})
